module.exports = __webpack_public_path__ + "w3box_logo_path.svg";